import React from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import SiteHeader from './Navigation/SiteHeader';
import EmulationBanner from './common/EmulationBanner';
import { useAuth } from '../contexts/AuthContext';

const AppLayout = ({ children }) => {
    const location = useLocation();
    const { isEmulating } = useAuth();

    // Define routes where the main header should NOT be shown
    const immersiveRoutes = [
        '/admin',
        '/dashboard',
        '/shipments',
        '/create-shipment',
        '/tracking',
        '/customers',
        '/reports',
        '/billing',
        '/profile',
        '/carriers',
        '/notifications',
        '/set-password',
        '/login',
        '/signup',
        '/terms',
        '/privacy'
    ];

    // Check if the current route or any of its sub-paths match the immersive routes
    // The homepage (HomepageX), the auth and sign-up pages (AuthShell, including
    // /signup/verify and /signup/finish) and the legal pages (LegalPage) bring
    // their own header, so "/" is immersive too.
    const isImmersiveRoute = location.pathname === '/'
        || immersiveRoutes.some(route => location.pathname.startsWith(route));

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            {/* Emulation Banner - Shows when emulating a user or role */}
            {isEmulating && <EmulationBanner />}
            {!isImmersiveRoute && <SiteHeader />}
            <Box component="main" sx={{ flexGrow: 1 }}>
                {children}
            </Box>
        </Box>
    );
};

export default AppLayout; 